import Rellax from 'rellax';
export const clouds = () => {
    var rellax = new Rellax('.cloud1',{ breakpoints:[576, 992, 1360],});
    var rellax = new Rellax('.cloud2',{ breakpoints:[576, 992, 1360]});
    var rellax = new Rellax('.cloud3',{ breakpoints:[576, 992, 1360]});
    var rellax = new Rellax('.cloud4',{ breakpoints:[576, 992, 1360]});
    var rellax = new Rellax('.cloud5',{ breakpoints:[576, 992, 1360]});
    var rellax = new Rellax('.cloud6',{ breakpoints:[576, 992, 1360]});
}

